const collection = {
  slug: "comme-des-garcons-2005aw-broken-bride-guide",
  metaTitle:
    "コムデギャルソン名作 Broken Brideとは｜2005AW壊れた花嫁と買取ガイド",
  metaDescription:
    "COMME des GARÇONS 2005AW『Broken Bride』を解説。白いドレス、壊れた花嫁、レース、ヴェール、祝福と崩壊が同居する川久保玲の名作コレクション。コムデギャルソン名作、アーカイブ価値、買取相談までEnclopediaが詳しく案内します。",
  metaKeywords:
    "コムデギャルソン Broken Bride,COMME des GARCONS 2005AW,Broken Bride,コムデギャルソン 名作,コムデギャルソン 花嫁,コムデギャルソン 白ドレス,川久保玲 名作,COMME des GARCONS Fall 2005,コムデギャルソン 2005AW,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン 高価買取,コムデギャルソン 古着 買取,コムデギャルソン レディース 買取,Enclopedia,アンクロペディア",
  canonicalPath:
    "/archive_collection/comme-des-garcons-2005aw-broken-bride-guide",
  heroImage: "media/archive_fashion/archive9.png",
  heroImageAlt:
    "COMME des GARÇONS 2005AW Broken Bride 壊れた花嫁を解説するEnclopediaアーカイブガイド画像",
  heroNumber: "10 / BROKEN BRIDE",
  label: "ARCHIVE COLLECTION STUDY",
  title: "COMME des GARÇONS 2005AW『Broken Bride』",
  lead: "COMME des GARÇONS 2005AW『Broken Bride』。\n白いドレス、壊れた花嫁、レース、ヴェール、花飾り。\n\n祝福されるはずの花嫁が、どこか崩れている。\nロマンチックなのに不穏。\n美しいのに、少し怖い。\n\nこのコレクションには、川久保玲が作る“美しいけど怖い”という感覚が濃く表れています。\n結婚や花嫁という最も祝福されたイメージを使いながら、その内側にある制度、儀式、束縛、崩壊まで見せてしまう。\nそれがBroken Brideの強さです。",
  keywordLine: ["broken bride", "white dress", "rei kawakubo", "buyback guide"],
  thesis:
    "『Broken Bride』の重要性は、花嫁というロマンチックな記号を使いながら、祝福と崩壊、美しさと怖さ、儀式と反抗を同時に見せた点にあります。",
  whyTitle: "なぜ『Broken Bride』は、“美しいけど怖い”名作なのか。",
  whyBody:
    "花嫁は、一般的には祝福、純白、幸福、未来、儀式を象徴します。\n白いドレス、レース、ヴェール、花飾り。\nそれらはファッションの中でも、最もロマンチックで分かりやすい記号です。\n\nしかしCOMME des GARÇONS 2005AWは、その花嫁像をそのまま美しく提示しません。\n白いレースやラッフルは確かに美しい。\nけれど、そこにはどこか過剰さがあり、顔を覆うヴェールや白く塗られた表情、儀式的なムードが、不穏な空気を作ります。\n\nVogue Runwayはこのコレクションを、レースやラッフル、ヴィクトリアン調のロマンチックな創造物、そして花嫁たちの行列として描写しています。さらに川久保玲が、この婚礼的な儀式を“anticonservatism”として語ったことにも触れています。\n\nつまりBroken Brideは、単なるブライダルの引用ではありません。\n結婚という制度、花嫁という役割、美しい白という幻想を、川久保玲が静かに壊しているコレクションです。\nEnclopediaでは、このような名作の文脈を入口に、コムデギャルソンのアーカイブ価値を読み取り、買取やレンタルを通じて次のユーザーへつなげます。",
  pillars: [
    {
      number: "01",
      title: "BRIDE AS SYMBOL",
      text: "花嫁は、純白、祝福、幸福、制度を象徴する強い記号です。Broken Brideは、その記号を使いながら、花嫁像そのものを揺さぶります。",
    },
    {
      number: "02",
      title: "ROMANCE AND FEAR",
      text: "白いレースやヴェールは美しい。しかし過剰に重なり、顔や身体を覆うことで、その美しさは少し怖いものへ変わります。",
    },
    {
      number: "03",
      title: "ARCHIVE AS VALUE",
      text: "COMME des GARÇONSの名作は、古い服だから価値があるのではありません。時間が経っても問いが残り、今も読み直せるからアーカイブとして評価されます。",
    },
  ],
  readingTitle: "白、花嫁、レース、崩壊から読む『Broken Bride』。",
  readingIntro:
    "このコレクションは、白いドレスが美しいから名作なのではありません。なぜ花嫁が壊れて見えるのか、なぜ祝福が不穏に見えるのか、なぜロマンチックな装飾が怖さに変わるのかを見ることで、川久保玲の深度が見えてきます。",
  observations: [
    {
      index: "01",
      title: "白は、純粋さではなく不穏さを帯びる",
      text: "白いドレスは、普通なら純粋さや祝福を象徴します。\nしかしBroken Brideの白は、単に清らかな色ではありません。\nレース、チュール、ヴェール、フリルが重なり、白はどこか過剰で、儀式的で、少し怖い色になります。\n\n白は無垢を表すと同時に、空白、沈黙、死装束のような気配も帯びる。\n川久保玲は、その曖昧さを利用して、花嫁というイメージを美しいだけでは終わらせません。",
    },
    {
      index: "02",
      title: "花嫁は祝福される存在であり、制度に包まれる存在でもある",
      text: "花嫁という存在には、幸福や祝福のイメージがあります。\nしかし同時に、結婚という制度、家族、宗教、社会的な役割とも結びついています。\n\nBroken Brideでは、花嫁はただ幸せそうには見えません。\nヴェールに覆われ、白い装飾に包まれ、儀式の中に固定されているようにも見える。\n\nその姿は、祝福と束縛が同じ場所にあることを示しています。\nここに、このコレクションの不穏さがあります。",
    },
    {
      index: "03",
      title: "レースやラッフルは、甘さではなく過剰さになる",
      text: "レース、ラッフル、フリルは、本来ロマンチックで甘い装飾です。\nしかしCOMME des GARÇONSでは、それらが単なる可愛さとして使われません。\n\n重なりすぎるレース。\n覆いすぎるヴェール。\n身体の輪郭を曖昧にする白い量感。\n\n装飾が増えるほど、花嫁は美しくなるのではなく、どこか異様な存在になります。\n甘さが過剰になることで、怖さに変わる。\nそれがBroken Brideの魅力です。",
    },
    {
      index: "04",
      title: "“壊れた花嫁”は、花嫁像そのものへの反抗である",
      text: "Broken Brideという呼び方が強いのは、花嫁という完成されたイメージが壊れているからです。\n理想的な花嫁、幸せな花嫁、美しい花嫁。\nその完成された像に、川久保玲は亀裂を入れます。\n\n花嫁は本当に幸福の象徴なのか。\n白いドレスは本当に純粋さだけを意味するのか。\n結婚という儀式は、本当に祝福だけでできているのか。\n\nこのコレクションは、それらの問いを服で提示しています。",
    },
    {
      index: "05",
      title: "ロマンチックなのに不穏、という川久保玲らしさ",
      text: "川久保玲の服には、“美しいけど怖い”という感覚があります。\nBroken Brideは、その感覚が非常に分かりやすく表れたコレクションです。\n\n白いドレスは美しい。\nレースも花飾りも美しい。\nけれど、全体として見ると、どこか穏やかではない。\n\nロマンチックなものを、そのままロマンチックに終わらせない。\n美しいものの中にある不安や制度性まで見せてしまう。\nそこにCOMME des GARÇONSの強さがあります。",
    },
    {
      index: "06",
      title:
        "名作として残る理由は、テーマの分かりやすさと深さが両立しているから",
      text: "Broken Brideは、テーマだけを聞くと分かりやすいコレクションです。\n白いドレス、花嫁、レース、ヴェール。\nしかし、その奥には結婚、宗教、制度、祝福、崩壊、反保守性という複数の層があります。\n\nつまり、入口は分かりやすい。\nでも読み込むほど深い。\nこのバランスが、名作として残る理由です。\n\nコムデギャルソン初心者にも伝わりやすく、アーカイブ好きにも語れる。\nEnclopediaのSEO記事としても非常に相性が良いテーマです。",
    },
    {
      index: "07",
      title: "買取で見るべきなのは、古さではなく文脈",
      text: "コムデギャルソンの買取では、単に古い服だから価値がある、という見方では不十分です。\nどのシーズンか。どのラインか。どんなテーマと接続しているか。どれだけブランド史の中で重要か。\n\n2005AW Broken Brideのような象徴的コレクションは、まさに文脈が価値になる代表例です。\nEnclopediaでは、コムデギャルソンの服を単なる古着としてではなく、ブランドの思想やコレクション背景まで含めて確認します。",
    },
  ],
  quote:
    "Broken Brideは、白いドレスのコレクションではない。祝福されるはずの美しさが、静かに崩れていく瞬間です。",
  perspectiveTitle:
    "Enclopediaは、コムデギャルソンを“古着”ではなく“問いが残るアーカイブ”として見る。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "2005AW『Broken Bride』を、白、花嫁、レース、祝福、崩壊、川久保玲の反保守性から読み解きます。",
    },
    {
      number: "02",
      title: "SERVICE ENTRY",
      text: "この記事は、コムデギャルソンの名作を知る入口であると同時に、Enclopediaが服をどのように読み、扱い、次へつなげるサービスなのかを知ってもらう入口です。",
    },
    {
      number: "03",
      title: "BUYBACK",
      text: "買取対象は2005AWだけに限定しません。COMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全般を文脈込みで相談対象として見ます。",
    },
  ],
  experienceTitle:
    "コムデギャルソンを売る前に、その一着がどの文脈にあるかを確認する。",
  experienceBody:
    "コムデギャルソンの買取では、ブランド名だけでなく、ライン、年代、シーズン、デザイナー、素材、状態、現在の需要が重要です。\n今回の記事では2005AW『Broken Bride』を中心に解説していますが、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSなど、コムデギャルソン全般を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n名作コレクションを知ることは、自分の持っている一着の価値を見直す入口になります。",
  experienceItems: [
    "COMME des GARÇONSのライン名を確認する",
    "タグ・品質表示・年代・シーズンが分かる写真を撮影する",
    "白、レース、フリル、ヴェール、花飾りなどのディテールを確認する",
    "HOMME PLUS、JUNYA、noirなどラインごとの特徴を確認する",
    "2005AWなど名作シーズンに近い文脈があるか確認する",
    "シーズンや価値が分からない場合もLINEで写真を送る",
  ],
  archiveItemsTitle: "コムデギャルソンの名作を入口に、買取相談へつなげる。",
  archiveItemsBody:
    "Enclopediaでは、コムデギャルソンを単なるブランド古着としてではなく、コレクション背景、ライン、年代、思想、現在の需要まで含めて見ています。この記事で2005AW Broken Brideの重要性に触れた方は、所有しているコムデギャルソンの一着も、まずはLINEでご相談ください。",
  archiveItems: [
    {
      label: "BUYBACK FOCUS 01",
      title: "コムデギャルソン買取ページへ",
      productPath: "/brand_buyback/comme-des-garcons",
      productImage: "",
      text: "COMME des GARÇONS、HOMME PLUS、HOMME、JUNYA WATANABE、noir kei ninomiyaまで。コムデギャルソン全般の買取対象と査定視点を確認できます。",
    },
    {
      label: "BUYBACK FOCUS 02",
      title: "LINEでコムデギャルソンを事前査定",
      productPath: "https://line.me/R/ti/p/@240yzqkh",
      productImage: "",
      text: "タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。シーズンが分からない場合も相談可能です。",
    },
    {
      label: "SERVICE FOCUS 03",
      title: "Enclopediaのアーカイブレンタルを見る",
      productPath: "/",
      productImage: "",
      text: "Enclopediaは買取だけでなく、アーカイブを次の人が体験できるレンタルサービスです。服を所有物ではなく、文化として循環させます。",
    },
  ],
  finalCta: {
    title:
      "Broken Brideの記事を読んだら、次はEnclopediaでコムデギャルソンの価値を相談する。",
    body: "COMME des GARÇONS 2005AW『Broken Bride』は、コムデギャルソンの名作を知るための強い入口です。\nただし、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaまで、コムデギャルソン全般の価値をアーカイブの視点で確認します。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
    buttonLabel: "コムデギャルソンをLINEで事前査定する",
    buttonHref: "https://line.me/R/ti/p/@240yzqkh",
  },
};

export default collection;
